import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'

function LabelShuffle(props) {
  //Values from client
  const {
    coordinateArray,
    isVerifyMode,
    isPractice,
    Completed,
    explanationClick,
    selectedValue,
    isActive,
    isAudioPlaying
  } = props

  //Values to client
  const {
    isImageLoaded,
    validateCorrectAnswerForShuffle,
    handleExplanationChange,
    clearSelectedItem
  } = props
  const [boxFocused, setBoxFocused] = useState(0)

  useEffect(() => {
    if (boxFocused > 0) {
      setTimeout(() => {
        setBoxFocused(-1)
      }, 2000)
    }
  }, [boxFocused])

  function allowDrop(ev) {
    ev.preventDefault()
  }

  return (
    <span
      style={{
        width: '100%',
        height: '100%',
        zIndex: 90
      }}
    >
      {isImageLoaded &&
        coordinateArray.map((box, index) => {
          const {
            ControlID,
            XAxis,
            YAxis,
            FontSize,
            Rotation,
            Weight,
            Width,
            Height,
            CorrectAnswer,
            defaultValue
          } = box

          return (
            <div
              key={ControlID.toString()}
              style={{
                position: 'absolute',
                top: YAxis,
                left: XAxis,
                transform: `rotate(${Rotation})`,
                transformOrigin: '0px 0px',
                minWidth: '10%',
                width: Width.concat('%'),
                height: Height.concat('%'),
                display: 'flex',
                borderColor: '#0bff31',
                borderWidth: '2px',
                display: 'flex',
                borderStyle: isVerifyMode ? 'solid' : 'none',
                fontSize: FontSize
              }}
            >
              <div
                style={{
                  width: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundColor: box === selectedValue ? 'yellow' : 'white',
                  boxShadow:
                    box.BoxOverlay &&
                    `${box.BoxOverlay.shadowColorValue} 0px 0px ${box.BoxOverlay.shadowOpacity}px ${box.BoxOverlay.shadowSpread}px`
                }}
                className={
                  defaultValue !== ''
                    ? isPractice || Completed === 1 || !isActive
                      ? box.defaultValue === box.CorrectAnswer
                        ? 'input-box correct-answer'
                        : 'input-box wrong-answer'
                      : 'input-box normal-input'
                    : 'input-box normal-input'
                }
                // className={
                //   defaultValue !== ''
                //     ? isPractice || Completed === 1 || !isActive
                //       ? box.defaultValue === box.CorrectAnswer
                //         ? 'green-box'
                //         : 'red-box'
                //       : 'black-box'
                //     : 'black-box'
                // }
                onClick={() => {
                  if (explanationClick) {
                    if (box.defaultValue === box.CorrectAnswer) {
                      handleExplanationChange(
                        true,
                        box.CorrectAnswerExplanation
                      )
                    } else {
                      handleExplanationChange(
                        false,
                        box.IncorrectAnswerExplanation
                      )
                    }
                  } else {
                    if (Completed === 0 && isActive && !isAudioPlaying) {
                      setBoxFocused(ControlID)
                      validateCorrectAnswerForShuffle(box)
                    }
                  }
                }}
                onDragStart={() => {
                  if (
                    Completed === 0 &&
                    isActive &&
                    !explanationClick &&
                    !selectedValue &&
                    !isAudioPlaying
                  ) {
                    setBoxFocused(ControlID)
                    validateCorrectAnswerForShuffle(box)
                  }
                }}
                draggable={
                  explanationClick
                    ? false
                    : selectedValue
                    ? selectedValue.ControlID === ControlID
                      ? true
                      : false
                    : true
                }
                onDrop={(event) => {
                  if (
                    Completed === 0 &&
                    isActive &&
                    !explanationClick &&
                    !isAudioPlaying
                  ) {
                    setBoxFocused(ControlID)
                    validateCorrectAnswerForShuffle(box)
                  }
                }}
                onDragOver={(event) => allowDrop(event)}
                onDragEnd={(event) => {
                  if (
                    event.dataTransfer &&
                    event.dataTransfer.dropEffect &&
                    event.dataTransfer.dropEffect === 'none'
                  ) {
                    clearSelectedItem('clear')
                  }
                }}
              >
                <p style={{ margin: 'auto' }}>
                  {isVerifyMode ? CorrectAnswer : defaultValue}
                </p>
              </div>
            </div>
          )
        })}
    </span>
  )
}

export { LabelShuffle }
